import { HotkeyHint, HotkeyHintProps } from './hotkey-hint/HotkeyHint'
import './HotkeyHintsMenu.css'

export interface HotkeyHintsMenuProps {
	hints: HotkeyHintProps[]
}

export const HotkeyHintsMenu = ({ hints }: HotkeyHintsMenuProps) => {

	return (
		<div className='hotkey-hints-menu'>
			{hints.map(hint => (
				<HotkeyHint {...hint} />
			))}
		</div>
	)
}